{
  "viewer": {
    "newScreen": "New Screen",
    "screens": "Screens"
  }
}
